<div class="step-form">
  <div class="step-form__subtitle">
    Digite os e-mails de quem vai receber o acesso aos produtos Serasa a partir
    do usuário
    <span class="step-form__subtitle__user"
      >{{ cloneableLogon?.logon?.fullName }} - Logon:
      {{ cloneableLogon?.logon?.logon }}</span
    >.
  </div>

  @if (pmeLogonsCount) {
    <div class="step-form__pme-limit">
      {{ pmeLogonsCount.remainingCount }} logons disponíveis para criação
    </div>
  }

  @if (pmeLimitsUnavailable) {
    <pl-alert color="warning" display="block">
      <span header>Limite indisponível</span>
      <span content>
        Não foi possível obter o limite de logons PME. Prossiga com cautela.
      </span>
    </pl-alert>
  }

  @if (isPmeLimitAlmostReached()) {
    <div class="step-form__almost-limit-banner" role="alert" aria-live="polite">
      <span class="step-form__almost-limit-banner__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="var(--seds-color-brand-primary-base, #1A2B70)"/>
        </svg>
      </span>
      <div class="step-form__almost-limit-banner__content">
        <strong>Limite de acessos quase atingido</strong>
        <span>
          É possível criar mais {{ pmeLogonsCount?.remainingCount }} usuário{{ pmeLogonsCount?.remainingCount === 1 ? '' : 's' }}. Revise os acessos existentes e exclua os que não forem necessários para criar novos usuários.
        </span>
      </div>
    </div>
  }

  @if (pmeLimitReached) {
    <pl-alert color="error" display="block">
      <span header>Limite de logons atingido</span>
      <span content>
        Você atingiu a quantidade máxima de usuários desse contrato. Entre em
        contato com a nossa equipe de atendimento.
      </span>
    </pl-alert>
  }

  @if (hasError) {
    <pl-alert color="error" display="block">
      <span header>{{ errorMessage?.title }}</span>
      <span content>
        {{ errorMessage?.description }}
      </span>
    </pl-alert>
  }

  @if (failedCloneResults.length > 0) {
    <pl-alert color="warning" display="block">
      <span header>Não foi possível criar alguns usuários</span>
      <span content>
        @for (result of failedCloneResults; track result.email) {
          <div>
            • {{ result.email }}: {{ getFailedMessage(result) }}
          </div>
        }
      </span>
    </pl-alert>
  }

  <pl-email-id-list
    [entriesForm]="entriesForm"
    [maxEntries]="getEmailLimit()"
    [disabled]="pmeLimitReached"
  ></pl-email-id-list>
</div>
